export interface JSendResponse {
  data: any;
  message: string;
  status: string;
}

export interface DrilldownResponse {
  families: Array<IFamily>;
  path: Array<DrilldownPath>;
  products: Array<IProduct>;
}

export interface IProduct {
  id: number;
  name: string;
  marketingName: string;
  description: string;
  sortOrder: number;
  selected?: boolean;

  viewStatus: any;
  viewStatusNa: any;
  viewStatusSa: any;
  viewStatusCn: any;
  viewStatusRoa: any;
}

export interface IFamily {
  id: number;
  parentId: number;
  name: string;

  description: string;
  descriptionNa: string;
  descriptionSa: string;
  descriptionCn: string;
  descriptionRoa: string;

  image: string;
  imageNa: string;
  imageSa: string;
  imageCn: string;
  imageRoa: string;

  isVisible: boolean;
  isVisibleNa: boolean;
  isVisibleSa: boolean;
  isVisibleCn: boolean;
  isVisibleRoa: boolean;

  isArchived: boolean;
  isArchivedNa: boolean;
  isArchivedSa: boolean;
  isArchivedCn: boolean;
  isArchivedRoa: boolean;

  viewStatus: any;
  viewStatusNa: any;
  viewStatusSa: any;
  viewStatusCn: any;
  viewStatusRoa: any;

  sortOrder: number;
}

export class ModuleFamily implements IFamily {
  id: number;
  parentId: number;
  name: string;
  parent: any;

  description: string;
  descriptionNa: string;
  descriptionSa: string;
  descriptionCn: string;
  descriptionRoa: string;

  image: string;
  imageNa: string;
  imageSa: string;
  imageCn: string;
  imageRoa: string;

  isVisible: boolean;
  isVisibleNa: boolean;
  isVisibleSa: boolean;
  isVisibleCn: boolean;
  isVisibleRoa: boolean;

  isArchived: boolean;
  isArchivedNa: boolean;
  isArchivedSa: boolean;
  isArchivedCn: boolean;
  isArchivedRoa: boolean;

  isTunableWhite: boolean;

  viewStatus: any;
  viewStatusNa: any;
  viewStatusSa: any;
  viewStatusCn: any;
  viewStatusRoa: any;

  sortOrder: number;

  driverFamilyWhitelists: Array<any>;
  driversWhitelist: Array<any>;

  modulesNa: Array<any>;
  modulesSa: Array<any>;
  modulesCn: Array<any>;
  modulesRoa: Array<any>;

  metadata: any;

  constructor(name: string) {
    this.name = name;
  }

}

export interface DriverFamily extends IFamily {

}

export interface Module extends IProduct {

}

export interface DrilldownPath {
  id: number;
  name: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/drilldown.ts